import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { CommonList } from 'src/app/pap-creation/pap-dto/pap-dto';

@Component({
  selector: 'app-cerfa-lists',
  templateUrl: 'cerfa-lists.component.html',
  styleUrls: ['./cerfa-lists.component.less', '../../../shared/common.less'],
})

export class CerfaListsComponent implements OnInit {
  @Input() commonLists: CommonList[];
  @Output() commonListsChange = new EventEmitter<CommonList[]>();
  needPap: boolean = undefined;

  constructor() {}
  
  onCommonListsChange() {
    this.commonListsChange.emit(this.commonLists);
  }

  onlyNumbers(event: KeyboardEvent): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  deleteAt(i: number) {
    this.commonLists.splice(i, 1);
    this.onCommonListsChange();
  }

  trackByIndex(index: number): number {
    return index;
  }

  addCommonList() {
    this.commonLists.push({
      listName: '',
      listMembers: '',
      listMembersFullName: '',
      composition: 0
    });
    this.onCommonListsChange();
  }

  validateComposition(index: number) {
    const value = this.commonLists[index].composition;
    if (value > 100) {
      this.commonLists[index].composition = 100;
    } else if (value < 0) {
      this.commonLists[index].composition = 0;
    }
    this.onCommonListsChange();
  }

  
  ngOnInit(): void {
  }
}
